import React, { useState } from "react";
import LeftBar from "../left-side-bar";
import RightBar from "../right-side-bar";
import BookmarkMainContent from "./main-content";

const BookmarkComponent = () => {
  const [topicsQueryString, settopicsQueryString] = useState<string>("");

  return (
    <div className="bg-gray-100 h-full relative">
      <div className="p-4">
        <div className="mx-5 grid grid-cols-1 lg:grid-cols-12 gap-4">
          {/* Left Sidebar */}
          <LeftBar setTopicsQueryString={settopicsQueryString} />

          {/* Main Content */}
          <BookmarkMainContent topicsQueryString={topicsQueryString} />

          {/* Right Sidebar */}
          <RightBar />
        </div>
      </div>
    </div>
  );
};

export default BookmarkComponent;
